import { render, staticRenderFns } from "./PageCourseFilter.vue?vue&type=template&id=5723df2a&"
import script from "./PageCourseFilter.vue?vue&type=script&lang=js&"
export * from "./PageCourseFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports